import type { ChromosomeLocation } from "../ChromosomeLocation.js";
import { chromosomeArmShorthandNameMap } from "../names/chromosomeArmShorthandNameMap.js";
import { chromosomeNameMap } from "../names/chromosomeNameMap.js";

export function getChromosomeLocationText(location: Omit<ChromosomeLocation, "color">): string {
	const parts: (string | number)[] = [
		chromosomeNameMap[location.chromosome],
		chromosomeArmShorthandNameMap[location.arm],
	];

	if (location.region !== undefined) {
		parts.push(location.region);
	}
	if (location.band !== undefined) {
		parts.push(location.band);
	}
	if (location.subBand !== undefined) {
		parts.push(`.${location.subBand}`);
	}

	return parts.join("");
}
